import _ from "lodash";
import { sortAlphaNumeric } from "@/utils";

export const columns = (options, filters, sorter) => {
  const data = [
    {
      title: "Наименование кампании",
      dataIndex: "campaign_name",
      sorter: true,
      sorterType: "string",
    },
    {
      title: "АОН",
      dataIndex: "a_number_aons_set_name",
      sorter: true,
      sorterType: "string",
    },
    {
      title: "Количество контактов",
      dataIndex: "contacts_count",
      sorter: true,
      sorterType: "number",
    },
    {
      title: "Группа операторов",
      dataIndex: "operator_group_name",
      sorter: true,
      sorterType: "string",
    },
    {
      title: "Статус",
      dataIndex: "campaign_status",
      sorter: true,
      sorterType: "string",
    },
    {
      title: "Тип кампании",
      dataIndex: "scenario_id",
      sorter: true,
      sorterType: "number",
    },
    {
      title: "Действия",
      dataIndex: "actions",
      width: 180,
    },
  ];

  if (options) {
    Object.keys(options).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1) data[index] = { ...data[index], ...options[dataIndex] };
    });
  }

  if (filters) {
    Object.keys(filters).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1 && filters[dataIndex])
        data[index].filteredValue = filters[dataIndex];
    });
  }

  if (sorter) {
    Object.keys(sorter).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1 && sorter[dataIndex]) {
        data[index].sortOrder = sorter[dataIndex];
        data[index].sorter = (a, b) => {
          return sortAlphaNumeric(a[dataIndex], b[dataIndex]);
        };
      }
    });
  }

  return data;
};

export const statuses = {
  NOT_STARTED: { text: "Новая", action: "Новая" },
  PAUSED: { text: "В паузе", action: "Пауза" },
  DIALING: { text: "На обзвоне", action: "Запустить на обзвон" },
  ON_HOLD: { text: "На удержании", action: "На удержание" },
  FINISHED: { text: "Завершена" },
  ENDED: { text: "Завершена", action: "Завершить" },
  // ENDED: { text: "Приостановлена", action: "Приостановить" },
  EDIT: { action: "Редактировать" },
  DELETED: { text: "Удалена" },
  DELETE: { action: "Удалить" },
  ADD_CONTACTS: { action: "Добавить контакты" },
  PREVIEW: { action: "Предпросмотр" },
};
